import apiClient from '@/services/axios'

export async function get(id) {
  
  var response = await apiClient.get(process.env.VUE_APP_CRM_API_BASE_URL + '/GuestProfiles/value?id=' + id)
  if (response) {
    return response.data
  }

  throw new Error('Unable to get guest values')
}
